import { render, staticRenderFns } from "./RegistroEnvioLabsAux.vue?vue&type=template&id=ab26d1be"
import script from "./RegistroEnvioLabsAux.vue?vue&type=script&lang=js"
export * from "./RegistroEnvioLabsAux.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports